import { jsx as _jsx } from "react/jsx-runtime";
export const SIUnits = ({ node }) => {
    var _a;
    const space = node.number == null ? '' : ' ';
    const title = `${(_a = node.number) !== null && _a !== void 0 ? _a : ''}${space}${node.alt}`;
    return _jsx("span", { title: title, children: node.value });
};
const SI_RENDERERS = {
    si: SIUnits,
};
export default SI_RENDERERS;
